import React, { useEffect, useState } from 'react';
import styles from './CheckList.module.css';

const CheckList = ({ data = [], show, handleChange, resetAll }) => {
  return (
    <div>
      {show && (
        <div className={styles.container}>
          {data.map((item) => (
            <div key={item.name}>
              <input
                name={item.name}
                checked={item.value}
                type="checkbox"
                onChange={handleChange}
              />
              <span>{item.title}</span>
            </div>
          ))}
          {resetAll !== undefined && (
            <div className={styles.resetButton} onClick={resetAll}>
              Restart
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CheckList;
